import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/AddCircle';
import RemoveIcon from '@material-ui/icons/RemoveCircle';
import VideoCallIcon from '@material-ui/icons/VideoCall';
import { Alert, AlertTitle } from '@material-ui/lab';

import Speaker from './Speaker';
import PlayButton from './PlayButton';

const useStyles = makeStyles(theme => ({
  background: {
    backgroundColor: '#cca',
    backgroundSize: 'cover',
    backgroundPosition: 'center center'
  },
  image: {
    width: '100%',
    maxWidth: "150px",
    height: "auto",
  },
  content: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    marginBottom: theme.spacing(1)
  },
  collapse: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },
  name: {
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  title: {
    color: theme.palette.primary.main,
    minHeight: '60px',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  date: {
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  time: {
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    fontWeight: 400,
    marginBottom: theme.spacing(1)
  },
  cpd: {
    color: "#777"
  },
  subtitle: {
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
    marginBottom: theme.spacing(2),
  },
  description: {
    fontSize: '12px',
    margin: 0,
    marginBottom: theme.spacing(2),
    whiteSpace: 'pre-line'
  },
  button: {
    textTransform: 'none',
    marginLeft: -theme.spacing(1),
  },
  speaker: {
    marginTop: theme.spacing(3),
  },
  chair: {
    marginTop: theme.spacing(3),
  },
  sponsor: {
    marginTop: theme.spacing(3),
  },
  position: {
    color: "#333",
    fontWeight: 400,
    marginBottom: theme.spacing(2),
  },
  zoom: {
    marginTop: theme.spacing(3),
  },
}));
export default (props) => {
  const [isOpen, setOpen] = useState(false);
  const classes = useStyles();
  return (
    <Paper style={{ marginBottom: "20px" }}>
      <Grid container direction="row">
        <Grid item sm={5} xs={6} className={classes.background} style={{ backgroundImage: `url("${props.config.imageUrl}")` }}>
          <div className={classes.content}>
            <PlayButton config={props.config} setVideoSrc={props.setVideoSrc} />
          </div>
        </Grid>
        <Grid item sm={7} xs={6}>
          <div className={classes.content}>
            <div><h6 className={classes.name}>{props.config.name}</h6></div>
            <div><h4 className={classes.title}>{props.config.title}</h4></div>
            {props.config.date &&
              <div><h5 className={classes.date}>{props.config.date}</h5></div>
            }
            <div><h6 className={classes.time}>{props.config.time}</h6></div>
            {!isOpen &&
              <Button color="primary" className={classes.button} startIcon={<AddIcon />} onClick={e => setOpen(!isOpen)} > show more </Button>
            }
            {isOpen &&
              <Button color="primary" className={classes.button} startIcon={<RemoveIcon />} onClick={e => setOpen(!isOpen)} > show less </Button>
            }
          </div>
        </Grid>
      </Grid>
      <Collapse in={isOpen}>
        <div className={classes.collapse}>
          <p className={classes.description}>{props.config.description}</p>

          {/* {props.config.zoomUrl && (
            <Alert
              severity="info"
              action={
                <Button variant="contained" color="primary" size="small" disableElevation startIcon={<VideoCallIcon />} href="https://zoom.us/download" target="_blank" rel="noopener noreferrer">download</Button>
              }
            >
              <AlertTitle>ZOOM Conference</AlertTitle>
              This discussion group is an open public forum. You are welcome to join the conversation by downloading and installing the online 'zoom' video call client.
            </Alert>
          )} */}

          {props.config.speakers &&
            <div className={classes.speaker}>
              <div><h4 className={classes.subtitle}>{ props.config.speakers.length===1 ? 'Speaker' : 'Speakers' }</h4></div>
              {props.config.speakers.map((speaker, index) =>
                <Speaker config={speaker} key={index} />
              )}
            </div>
          }

          {props.config.facilitators &&
            <div className={classes.chair}>
              <div><h4 className={classes.subtitle}>{ props.config.facilitators.length===1 ? 'Facilitator' : 'Facilitators' }</h4></div>
              {props.config.facilitators.map((speaker, index) =>
                <Speaker config={speaker} key={index} />
              )}
            </div>
          }

          {props.config.sponsors &&
            <div className={classes.sponsor}>
              {/* <div><h4 className={classes.subtitle} style={{marginBottom: 0}}>{ props.config.sponsors.length===1 ? 'Sponsor' : 'Sponsors' }</h4></div> */}
              <div><h6 className={classes.position}>{props.config.sponsorTitle}</h6></div>
              <Grid container direction="row">
              {props.config.sponsors.map((sponsor, index) =>
                  <Grid item xs={6} key={index}>
                    <img src={sponsor.imageUrl} alt={sponsor.imageAlt} className={classes.image} />
                  </Grid>
                )}
              </Grid>
            </div>
          }
        </div>
      </Collapse>
    </Paper>
  );
}
